// extracted by mini-css-extract-plugin
module.exports = {"root":"industrial-alcohol-disposal-page_root__gMlFd"};